import store from "@/js/store";

export async function sendPasswordResetEmail(email, additionalText) {
	await store.dispatch("sendPasswordResetEmail", email);
	let message = "";
	if (additionalText) message = `${additionalText}<br>`;
	message += `An email has been sent to <b>${email}</b> with further instructions`;
	window.VueApp.prototype.$toast(message)
}
